export default "__VITE_ASSET__DrA4RTwM__"